import { BannerInfo } from 'models/bannerInfo'

export const BannerInfoResolver = {
    bannerInfo: () =>
        ({
            __typename: 'bannerInfo-JeldWen',
            displayName: 'Jeld-Wen',
            subTitle: 'Jeld-Wen Windows and Doors',
            bannerImageUrl:
                'https://avitrucdn.azureedge.net/bpm/company_home_banner.png',
        } as BannerInfo),
}
